export default __webpack_public_path__ + "static/media/account-daily-report-cards.ab4ac722.md";